import gsap from "gsap";
import React, { useEffect, useRef } from "react";

function ComingSoon() {
  const ref = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      ref.current,
      { autoAlpha: 0 },
      { duration: 2.5, autoAlpha: 1, repeat: -1 }
    );
  });
  return (
    <div
      ref={ref}
      className="text-[#ffffff] text-[50px] font-semibold max-[481px]:text-[18px]"
    >
      Coming Soon
    </div>
  );
}

export default ComingSoon;
